import { styled } from "@mui/material/styles";
import { LoadingButton } from "@mui/lab";

export const StyledLoadingButton = styled(LoadingButton)(({ theme }) =>
    theme.unstable_sx({
        minHeight: "51px",
    }),
);

export const BankIdImage = styled("img")({
    height: "32px",
    marginRight: "10px",
    objectFit: "cover",
    overflow: "auto",
});
